import { render, staticRenderFns } from "./font-icon.vue?vue&type=template&id=464d7c5f&"
import script from "./font-icon.vue?vue&type=script&lang=ts&"
export * from "./font-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports